// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Layouts[data-v-4a74cb30] {\n  width: 100%;\n  padding: 0 16px 40px;\n  display: flex;\n  flex-direction: column;\n}\n.Layouts .body[data-v-4a74cb30] {\n  display: flex;\n  flex-direction: column;\n  margin-right: -40px;\n  margin-top: -16px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
